import React, { useEffect, useState } from "react";
import Pilot from "../../model/Pilot";
import { useNavigate, useParams } from "react-router-dom";
import { useApiClient } from "../../contexts/ApiClientContext";
import { useAuth } from "../../contexts/AuthContext";
import { useAlerts } from "../../contexts/AlertsContext";
import APIEndPoints from "../../utils/APIEndPoints";
import AlertMessageType from "../common/alert_message/AlertMessageType";
import SETTINGS from "../../globals";
import AppSections from "../../utils/AppSections";
import AppSubSections from "../../utils/AppSubSections";
import { IApiClientError } from "../../shared/ApiClient";
import APIError from "../../utils/APIError";
import Button from "../common/button/Button";
import ButtonAction from "../common/button/ButtonAction";
import DialogWindowType from "../common/dialog_window/DialogWindowType";
import Loading from "../common/Loading";
import FormContainer from "../common/FormContainer";
import { FaInfoCircle } from "react-icons/fa";
import FormInputText from "../common/FormInputText";
import FormDropDown from "../common/FormDropDown";
import FormInputNumber from "../common/FormInputNumber";
import FormTextArea from "../common/FormTextArea";
import UploadManager from "../../shared/UploadManager";
import FormInputImage from "../common/FormInputImage";
import ImgUtil from "../../utils/ImgUtil";
import UploadFileType from "../../model/enums/UploadFileType";
import SpatialRelation from "../../model/SpatialRelation";
import InclusionType from "../../model/enums/InclusionType";
import ConditionReport from "../../model/ConditionReport";
import ConservationState from "../../model/enums/ConservationState";
import ConditionReportDocument from "./ConditionReportDocument";
import ConditionReportsList from "./CondtionReportsList";



function CoditionReportCreateChoice() {
  // read the ID from the url
  const { e3did} = useParams();
  const { chelementID } = useParams();

  // manage loading animation
  const [loading, setLoading] = useState(true);
  // set the state to track any error messages received from the server
  const [errorMessage, setErrorMessage] = useState("");
  // set state 
  const [browse, setBrowse] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [selectedCID, setSelectedCID] = useState(-1);



  // reference to the ApiClient instance
  const apiClient = useApiClient();
  // get a reference to navigation component
  const navigate = useNavigate();
  // reference to the AuthManager
  const authManager = useAuth();
  // reference to the alerts system
  const alertsManager = useAlerts();
  // instance of UploadManager
  const [uploadManager] = useState(new UploadManager({ apiClient: apiClient }));

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    if(selectedCID>0){
      navigate(
        SETTINGS.get_path({
          section: AppSections.E3DS,
          id: parseInt(e3did!),
          additionalSections: [AppSections.CONDITION_REPORTS, selectedCID.toString()],
          subsection: AppSubSections.COPY,
        })
      );
    }else{
      // Display alert window message
      alertsManager.showAlertMessage({
        type: AlertMessageType.INFO,
        message: "Please select a Condition Report to import",
      });
    }

  };

  const formInputChange = (inputID: string, newValue: string) => {
    setSearchText(newValue);
  };

  const onFormCancel = () => {
    navigate(
      SETTINGS.get_path({
        section: AppSections.E3DS,
        id: parseInt(e3did!),
        additionalSections: [],
        subsection: AppSubSections.VIEW,
      })
    );
  };

  const handleItemClick = (cid: number) => {
    setSelectedCID(cid);
  }

  const pageTitle = "Create Condition Report";

  return (
    <FormContainer
      title={pageTitle}
      onSubmit={(e) => {
        handleSubmit(e);
      }}
        >
      <div className="flex justify-between gap-4">
        <Button 
          label={"Create New Report"}
          purpose={ButtonAction.UPDATE}
          isSubmit={false}
          className="w-1/2"
          onClick={() =>
            navigate(
              SETTINGS.get_path({
                section: AppSections.E3DS,
                id: parseInt(e3did!),
                additionalSections: [AppSections.CONDITION_REPORTS],
                subsection: AppSubSections.NEW,
              })
            )}
        />

        <Button
          label={"Import from existing Report"}
          purpose={ButtonAction.UPDATE}
          isSubmit={false}
          className="w-1/2"
          onClick={() => setBrowse(true)}
        />
      </div>

      {errorMessage && (
        <div className="form-submit-error">
          <FaInfoCircle />
          <div>{errorMessage}</div>
        </div>
      )}

      {/* <FormDropDown
        label="Conservation State:"
        id="cr-conservation_state"
        value={formData.conservation_state}
        required={true}
        options={conservation_state_options}
        onChange={(id, value) => formInputChange(id, value)} // Ensure it's properly passed
        // error={formErrors.conservation_state}
      /> */}

      {/* Horizontal separator */}
      <hr className="my-4 border-t-2 border-gray-300" />
      {browse && (
        <>
            <div>
              <FormInputText
                  label="Search Condition Report:"
                  id="name"
                  value={searchText}
                  placeholder="Condition Report"
                  onChange={formInputChange}
                />
            </div>


            {/* Condition Reports */}
            <div className="details-section">
                <h2>Condition Reports:</h2>
                <div className="details-section-content">
                <ConditionReportsList name={searchText} chelementid={chelementID} onItemClick={handleItemClick} itemSelectionMode={true}/>
                </div>
            </div>

            <div className="form-buttons-container">


              <Button
                label="Cancel"
                purpose={ButtonAction.CANCEL}
                onClick={() => onFormCancel()}
                className="w-1/2"
              />
              <Button
                label={"Import"}
                purpose={ButtonAction.SAVE} 
                isSubmit={true}
                className="w-1/2"
              />
            </div>

        </>
      )}
    </FormContainer>
  );
}

export default CoditionReportCreateChoice;
